import { SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';

const teamContactModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.email) {
    main['email'] = content.email;
  }
  if (content?.phone1) {
    main['telephone'] = content.phone1;
  }
  if (content?.['@components']?.university) {
    main['owner'] = generateSchema({
      type: content['@components'].university['@type'],
      content: content['@components'].university,
      state,
      partial: true,
    });
  }
};

export default teamContactModifier;
